/**
 * Enum đã hạch toán
 * tvhien 13.04.2023
 */
export default {
  UnPosted: 0,
  Posted: 1,
};
